// Works for football only
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

import { Position } from '@sorare/core/src/__generated__/globalTypes';
import { PositionIcon } from '@sorare/core/src/components/lineup/PositionIcon';
import { FILTERS } from '@sorare/core/src/lib/filters';
import {
  PlayablePosition,
  formatPosition,
  sortByPosition as sortByPositionFn,
} from '@sorare/core/src/lib/players';

import { makeFilter } from 'searchCards/RefineList';

const sortByPosition = (items: RefinementListItem[]) => {
  return items.sort((a, b) =>
    sortByPositionFn(b.value as PlayablePosition, a.value as PlayablePosition)
  );
};

export const RefinePosition = ({ hideTitle }: { hideTitle?: boolean } = {}) =>
  makeFilter(FILTERS.position, {
    formatOption: formatPosition,
    transformItems: sortByPosition,
    renderBefore: (o: string) => <PositionIcon position={o as Position} />,
    hideTitle,
  });
